/* Extras do cart drawer (portado da KlarCar). Asset fora do drawer:
 * o cart-drawer.js da Dawn troca innerHTML e script inline morre.
 * Inclui: prova social, relogio de urgencia, estado do cliente,
 * vigia do fade (estilos inline no fechamento), caca-fade generico
 * e painel de diagnostico (?fandebug=1). */
(function () {
  function social() {
    var caixas = [].slice.call(document.querySelectorAll('[data-fan-social]'));
    if (!caixas.length) return;
    var MIN = 5, MAX = 12;
    var dia = Math.floor(Date.now() / 86400000);
    var n;
    try {
      var salvo = JSON.parse(localStorage.getItem('fan_pessoas') || 'null');
      if (salvo && salvo.dia === dia) n = salvo.n;
      else {
        n = MIN + Math.floor(Math.random() * (MAX - MIN + 1));
        localStorage.setItem('fan_pessoas', JSON.stringify({ dia: dia, n: n }));
      }
    } catch (e) { n = MIN + Math.floor(Math.random() * (MAX - MIN + 1)); }
    caixas.forEach(function (caixa) {
      if (caixa.dataset.fanFeito) return;
      caixa.dataset.fanFeito = '1';
      var t = caixa.querySelector('[data-fan-social-txt]');
      if (t) t.innerHTML = t.innerHTML.replace('{n}', '<b>+' + n + '</b>');
      caixa.hidden = false;
    });
  }

  function estadoCliente() {
    var alvos = [].slice.call(document.querySelectorAll('[data-fan-lugar-cart]'));
    if (!alvos.length) return;
    var nome = null;
    try { nome = sessionStorage.getItem('fan_estado'); } catch (e) {}
    if (nome && nome !== '-') alvos.forEach(function (a) { a.textContent = nome; });
  }

  function relogio() {
    [].slice.call(document.querySelectorAll('[data-fan-cart-urgencia]')).forEach(umRelogio);
  }
  function umRelogio(caixa) {
    if (caixa.dataset.fanRelogio) return;
    caixa.dataset.fanRelogio = '1';
    var b = caixa.querySelector('[data-fan-cart-relogio]');
    /* mesmo alvo do countdown do header: meia-noite local (reset diario) */
    function alvoMeiaNoite() {
      var agora = new Date();
      return new Date(agora.getFullYear(), agora.getMonth(), agora.getDate() + 1, 0, 0, 0).getTime();
    }
    var ate = alvoMeiaNoite();
    function dd(n) { return (n < 10 ? '0' : '') + n; }
    function tique() {
      if (!caixa.isConnected) return;
      var t = ate - Date.now();
      if (t <= 0) { ate = alvoMeiaNoite(); t = ate - Date.now(); }
      var s = Math.floor(t / 1000);
      b.textContent = dd(Math.floor(s / 3600)) + ':' + dd(Math.floor(s / 60) % 60) + ':' + dd(s % 60);
      caixa.hidden = false;
      setTimeout(tique, 1000);
    }
    tique();
  }

  /* fade: drawer fechado nao pode manter veu - estilo inline vence tudo */
  function vigiaFade() {
    var cd = document.querySelector('cart-drawer');
    if (!cd) return;
    var ov = document.getElementById('CartDrawer-Overlay');
    if (cd.classList.contains('active')) {
      clearTimeout(window.__fanDisplayNone);
      cd.style.removeProperty('display');
      cd.style.removeProperty('visibility');
      if (ov) {
        ov.style.removeProperty('opacity');
        ov.style.removeProperty('visibility');
        ov.style.removeProperty('background');
      }
    } else {
      cd.style.setProperty('visibility', 'hidden', 'important');
      if (ov) {
        ov.style.setProperty('opacity', '0', 'important');
        ov.style.setProperty('visibility', 'hidden', 'important');
        ov.style.setProperty('background', 'transparent', 'important');
      }
      /* Safari/iOS deixa a camada GPU pintada mesmo com visibility:hidden
         (camada orfa). display:none destroi a camada - unica cura real. */
      clearTimeout(window.__fanDisplayNone);
      window.__fanDisplayNone = setTimeout(function () {
        var c2 = document.querySelector('cart-drawer');
        if (c2 && !c2.classList.contains('active')) c2.style.setProperty('display', 'none', 'important');
      }, 50);
    }
  }

  /* caca-fade: se nada esta aberto e um elemento escuro cobre a tela, mata */
  function cacaFade() {
    var aberto = document.querySelector('cart-drawer.active, details[open] > .menu-drawer-container, quick-add-modal[open], .quick-add-modal[open], details[open] > .search-modal');
    if (aberto) return;
    var vw = window.innerWidth, vh = window.innerHeight;
    var candidatos = document.querySelectorAll('body > *, body > * > *, body > * > * > *');
    candidatos.forEach(function (el) {
      var tag = el.tagName;
      if (tag === 'SCRIPT' || tag === 'STYLE' || tag === 'LINK') return;
      var cs = getComputedStyle(el);
      if (cs.position !== 'fixed' && cs.position !== 'absolute') return;
      if (cs.visibility === 'hidden' || cs.display === 'none' || parseFloat(cs.opacity) < 0.05) return;
      var r = el.getBoundingClientRect();
      if (r.width < vw * 0.85 || r.height < vh * 0.7) return;
      var m = cs.backgroundColor.match(/rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*([\d.]+))?\)/);
      var alfa = m ? (m[4] === undefined ? 1 : parseFloat(m[4])) : 0;
      var escuro = m && Number(m[1]) < 90 && Number(m[2]) < 90 && Number(m[3]) < 90;
      var temFiltro = cs.backdropFilter && cs.backdropFilter !== 'none';
      if ((escuro && alfa > 0.15 && alfa < 0.95) || temFiltro) {
        if (el.querySelector('input, form, img, a')) return;
        el.style.setProperty('opacity', '0', 'important');
        el.style.setProperty('visibility', 'hidden', 'important');
        el.style.setProperty('pointer-events', 'none', 'important');
        try { localStorage.setItem('fan_fade_culpado', (el.id || '') + '|' + String(el.className).slice(0, 80)); } catch (e) {}
      }
    });
  }
  function varre() {
    cacaFade();
    setTimeout(cacaFade, 500);
    setTimeout(cacaFade, 1400);
    setTimeout(cacaFade, 3000);
  }

  /* diagnostico visivel: abrir com ?fandebug=1 */
  function painelDebug() {
    if (window.location.search.indexOf('fandebug') === -1) return;
    var box = document.getElementById('fan-debug-box');
    if (!box) {
      box = document.createElement('div');
      box.id = 'fan-debug-box';
      box.style.cssText = 'position:fixed;bottom:70px;left:8px;right:8px;z-index:2147483647;background:#000;color:#0f0;font:11px/1.5 monospace;padding:8px;border-radius:6px;pointer-events:none;white-space:pre-wrap;';
      document.body.appendChild(box);
    }
    var cd = document.querySelector('cart-drawer');
    var ov = document.getElementById('CartDrawer-Overlay');
    var scd = cd ? getComputedStyle(cd) : null;
    var sov = ov ? getComputedStyle(ov) : null;
    var culpado = '-';
    try { culpado = localStorage.getItem('fan_fade_culpado') || '-'; } catch (e) {}
    box.textContent = 'drawer.class: ' + (cd ? cd.className : '?') +
      '\ndrawer vis/op: ' + (scd ? scd.visibility + ' / ' + scd.opacity : '?') +
      '\ndrawer bg: ' + (scd ? scd.backgroundColor : '?') +
      '\noverlay vis/op/bg: ' + (sov ? sov.visibility + '/' + sov.opacity + '/' + sov.backgroundColor : '?') +
      '\nculpado: ' + culpado + '\njs vivo: sim';
  }

  /* fechamento garantido: se o close() do tema falhar no meio (iOS), a
     classe active e removida na marra e o corpo destravado */
  function fechaNaMarra(e) {
    var alvo = e.target;
    var fechou = (alvo.closest && alvo.closest('.drawer__close')) || alvo.id === 'CartDrawer-Overlay' || (alvo.classList && alvo.classList.contains('cart-drawer__overlay'));
    if (!fechou) return;
    setTimeout(function () {
      var cd = document.querySelector('cart-drawer');
      if (cd && cd.classList.contains('active')) cd.classList.remove('active');
      document.body.classList.remove('overflow-hidden');
      vigiaFade();
    }, 150);
    setTimeout(function () {
      var cd = document.querySelector('cart-drawer');
      if (cd) cd.classList.remove('active');
      document.body.classList.remove('overflow-hidden');
      vigiaFade();
    }, 700);
  }
  document.addEventListener('click', fechaNaMarra, true);
  document.addEventListener('touchend', fechaNaMarra, true);

  function roda() { social(); relogio(); estadoCliente(); vigiaFade(); varre(); painelDebug(); }
  function liga() {
    roda();
    if (!window.__fanDbgIv && window.location.search.indexOf('fandebug') !== -1) {
      window.__fanDbgIv = setInterval(painelDebug, 1000);
    }
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    new MutationObserver(function () { roda(); })
      .observe(drawer, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', liga);
  else liga();
})();
